import headShark1 from "../../assets/new-ui/roadmap/roadmap-head-shark-1.png";
import headShark2 from "../../assets/new-ui/roadmap/roadmap-head-shark-2.png";
import headShark3 from "../../assets/new-ui/roadmap/roadmap-head-shark-3.png";
import headShark4 from "../../assets/new-ui/roadmap/roadmap-head-shark-4.png";
import headShark5 from "../../assets/new-ui/roadmap/roadmap-head-shark-5.png";
import headShark6 from "../../assets/new-ui/roadmap/roadmap-head-shark-6.png";
import headShark7 from "../../assets/new-ui/roadmap/roadmap-head-shark-7.png";
import headShark8 from "../../assets/new-ui/roadmap/roadmap-head-shark-8.png";
import headShark9 from "../../assets/new-ui/roadmap/roadmap-head-shark-9.png";
import headShark10 from "../../assets/new-ui/roadmap/roadmap-head-shark-10.png";
import roadmapFull from "../../assets/new-ui/roadmap/roadmap-full-new.png";
import roadmapLineMobile from "../../assets/new-ui/roadmap/roadmap-line-mobile-new.png";
import RoadmapElement from "./RoadmapElement";
import CoralLeftType1 from "../coral/CoralLeftType1";
import CoralRightType1 from "../coral/CoralRightType1";
import Bubble from "../coral/Bubble";
export default function Roadmap() {
  return (
    <div className="roadmapContainer">
      <CoralLeftType1 type={"big"} />
      <CoralRightType1 type={"big"} />
      <Bubble top={"10%"} />
      <Bubble bottom={"5%"} />
      <img className="roadmapLine" src={roadmapFull} alt="roadmap line" />
      <img
        className="roadmapLineMobile"
        src={roadmapLineMobile}
        alt="roadmap line"
      />
      <div className="element element1">
        <RoadmapElement
          headShark={headShark1}
          order={1}
          title={"Launch series 1: Sharks (Q4/2021)"}
          description={""}
        />
      </div>

      <div className="element element2">
        <RoadmapElement
          headShark={headShark2}
          order={2}
          title={"Opening marketplace + Auction function (Q1/2022)"}
          description={""}
        />
      </div>

      <div className="element element3">
        <RoadmapElement
          headShark={headShark3}
          order={3}
          title={"Pre-alpha release (Q2/2022)"}
          description={"IDO<br/>Closed beta version<br/>NFT sale"}
        />
      </div>

      <div className="element element4">
        <RoadmapElement
          headShark={headShark4}
          order={4}
          title={"Open beta version (Q3/2022)"}
          description={
            "Human & monster AI, NFT evolution, NFT breeding, produce function, social network ingame, character creation, PVP, PVE, Boss battle,....<br/>Metaverse land sale"
          }
        />
      </div>

      <div className="element element5">
        <RoadmapElement
          headShark={headShark5}
          order={5}
          title={"Open beta update (Q4/2022)"}
          description={
            "Country battle and world tournament on metaverse.<br/>Metaverse early access betting function, defi and banking ecosystem release"
          }
        />
      </div>

      <div className="element element6">
        <RoadmapElement
          headShark={headShark6}
          order={6}
          title={"Full 3D models and VR metaverse (Q1/2023)"}
          description={
            "Release more NFT: map, new NFT collections, pet <br/> More evolution and breeding mechanism <br/>Metaverse final version release"
          }
        />
      </div>

      <div className="element element7">
        <RoadmapElement
          headShark={headShark7}
          order={7}
          title={"Open sources (Q2/2023)"}
          description={
            "Developers and producers can create games and business models using existing Sharktopia assets and integrate them into the ocean economy/ their metaverse land."
          }
        />
      </div>

      {/* <div className='element element8'>
        <RoadmapElement 
          headShark={headShark8} 
          order={8} 
          title={'DEFI LENDING, DEX + Voting for Series 3 (Q3/2022)'} 
          description={'Develop and integrate DEFI LENDING, DEX to Sharktopia to build a closed economy.<br/> Everyone can work, earn and live in Sharktopia forever. '}
        />
      </div>

      <div className='element element9'>
        <RoadmapElement 
          headShark={headShark9} 
          order={9} 
          title={'All in Holy metaverse - VR world (Q1/2023 - Q2/2023)'} 
          description={'Integrate all of Sharktopia ecosystem into one game that everyone can participate in Ocean economy easier by using VR technology. <br/>Social network <br/>Marketplace<br/>New auction model <br/>Sharks programming ( Leveling, evolution) <br/>PvP tournament and world ranking <br/> Crop, mining, breeding on Holylands<br/> PvE/ working mode<br/> World boss'}
        />
      </div>

      <div className='element element10'>
        <RoadmapElement 
          headShark={headShark10} 
          order={10} 
          title={'Great economy(Q4/2023)'} 
          description={'Launch Series 3: Open for sale of characters in Series 3 based on the previous Voting<br/>Build the missing parts to increase the efficiency of the ocean economy.<br/>Developers and producers can create games & business models using existing Sharktopia assets and integrate them into the ocean economy.'}
        />
      </div> */}
    </div>
  );
}
